var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataPipeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14950_1388)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_14950_1388",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 6,
    height: 10,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 6,
    height: 10,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_14950_1388)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_14950_1388",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    width: 6,
    height: 10,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7,
    width: 6,
    height: 10,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 4,
    mask: "url(#path-2-inside-2_14950_1388)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 10,
    height: 5,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 3.33333C16.9998 3.33333 15.1168 2 12.3332 2C9.54954 2 7.6665 3.33333 7.6665 3.33333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5L9.5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50016 20.6667C7.50016 20.6667 9.3832 22 12.1668 22C14.9505 22 16.8335 20.6667 16.8335 20.6667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20.5L15 19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14950_1388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPipeline);
export default __webpack_public_path__ + "static/media/data-pipeline.9c9aa283592018f595d7093075e8f8d8.svg";
export { ForwardRef as ReactComponent };